import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import 'overlayscrollbars/overlayscrollbars.css';
import { useFormat } from '../../../components/FormatContext';
import { DASHBOARD_ROUTES } from '../utils/dashboardConstants';
import { getBookingStatusClassName } from '../utils/dashboardHelpers';

const DashboardLatestBookingsTable = ({ data = [] }) => {
    const { baseFormatters } = useFormat();

    return (
        <Card className="p-1" style={{ minHeight: '400px' }}>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Latest Bookings</h5>
                <NavLink to={DASHBOARD_ROUTES.BOOKINGS_LIST} className="active-rmb-link block-link">
                    <span>
                        View more <FaChevronRight />
                    </span>
                </NavLink>
            </Card.Header>

            <Card.Body className="py-1 fs-14" style={{ flex: 1, overflowY: 'hidden' }}>
                <OverlayScrollbarsComponent
                    options={{
                        scrollbars: {
                            theme: 'os-theme-custom',
                        },
                    }}
                    style={{ maxHeight: '300px' }}
                >
                    <Table striped hover>
                        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
                            <tr>
                                <th scope="col">Booking ID</th>
                                <th scope="col">Date Time</th>
                                <th scope="col">Customer</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.length ? (
                                data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>
                                            {baseFormatters.datetime.format(new Date(item.pickupDateTime))}
                                            <br />
                                            {baseFormatters.datetime.format(new Date(item.returnDateTime))}
                                        </td>
                                        <td>
                                            {item.customerName}
                                            <br />
                                            {item.customerEmail}
                                        </td>
                                        <td className={getBookingStatusClassName(item.status)}>{item.status}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center py-4">
                                        No Data
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </OverlayScrollbarsComponent>
            </Card.Body>
        </Card>
    );
};

export default DashboardLatestBookingsTable;